import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.styl']
})
export class AppComponent {
  constructor(
    private sanitizer: DomSanitizer
  ) { }

  title = 'edu-expo';
  mapurl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.MAP_URL);
}
